<template>
	<div class="page-dashboard relative">
		<div class="text-center">
			<loading :active.sync="isResetting" :background-color="colorOverlay" :color="colorLoading">
				<template slot="after">
					<div class="absolute mt-1 ml-1">{{ $t('Sending') }}...</div>
				</template>
			</loading>
		</div>
		<div class="container-fluid">
			<h2 class="text-primary mb-4">
				{{ $t(title) }}
			</h2>
			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<div class="mr-4">
					<button
						class="btn btn-default"
						@click="addItem">
						{{ $t('Invite Collaborator') }}
					</button>
				</div>
				<!-- export -->
				<!-- <div v-if="items.length > 0">
					<label  class="btn btn-primary ml-a mr-2 mb-0 mw-fc">
						<div>
							<div @click="isExportUserVisible = true">{{ $t('Export Collaborator') }}</div>
						</div>
					</label>
				</div> -->
				<div class="col-lg-3" v-if="filteredInvitedOptions.length !== 0 && user.roles.includes('super_admin')">
					<select
						name="inviter"
						class="form-control"
						v-model="inviter"
						@change="fetch()"
						required
						placeholder="Inviter">
						<option value="All">
							<span>{{$t('By Me')}}</span>
						</option>
						<option
							v-for="inviter in filteredInvitedOptions"
							:key="inviter.id"
							:value="inviter.inviter_id">
							{{ inviter.inviter_name }}
						</option>
					</select>
				</div>
				<!-- counting -->
					<!-- is last Login -->
					<div class="verified-icon-left text-center ml-a"><i class="material-icons text-white absolute pt-1">login</i></div>
					<div class="mr-3">
						<md-menu md-align-trigger :md-offset-x="-21">
							<button class="btn btn-filter-last-login p-0 m-0" md-menu-trigger>
									<span class="capitalize" v-if="orderBy === 'id'">{{$t('All')}}</span>
									<span class="capitalize" v-if="orderBy === 'logged_in_at'">{{$t('Last Login')}}</span>
							</button>
							<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
							<md-menu-content>
								<md-menu-item @click="lastLoginAt('all')"><span class="text-center minw-85">{{$t('All')}}</span></md-menu-item>
								<md-menu-item @click="lastLoginAt('last')"><span class="text-center minw-85">{{$t('Last Login')}}</span></md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
					<!-- sort by-->
					<div class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1 text-lg pt-2">filter_list</i></div>
					<div class="mr-3">
						<md-menu md-align-trigger :md-offset-x="-20">
							<button class="btn btn-filter-last-transaction p-0 m-0" md-menu-trigger>
									<span class="tf-none" v-if="sortBy === 'desc'">{{$t('Newest on top')}}</span>
									<span class="tf-none" v-if="sortBy === 'asc'">{{$t('Newest on last')}}</span>
							</button>
							<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
							<md-menu-content>
								<md-menu-item @click="sortFilter('desc')"><span class="text-center minw-115">{{$t('Newest on top')}}</span></md-menu-item>
								<md-menu-item @click="sortFilter('asc')"><span class="text-center minw-115">{{$t('Newest on last')}}</span></md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
					<!-- limit -->
					<md-menu md-align-trigger md :md-offset-x=10 class="mr-3">
						<button class="btn-icon btn p-0 m-0 w-100 btn-click" md-menu-trigger>
								{{ page * limit - (limit - 1) }} - {{ items.length > 0 ? page * limit : items.length }} of {{ totalItems }}
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="changeLimit(10)"><span class="text-center minw-50">10</span></md-menu-item>
							<md-menu-item @click="changeLimit(25)"><span class="text-center minw-50">25</span></md-menu-item>
							<md-menu-item @click="changeLimit(50)"><span class="text-center minw-50">50</span></md-menu-item>
							<md-menu-item @click="changeLimit(100)"><span class="text-center minw-50">100</span></md-menu-item>
							<md-menu-item @click="changeLimit(200)"><span class="text-center minw-50">200</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				<div>
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>
			<!-- Main Table -->
			<table class="table table-striped mb-4">
				<thead>
					<tr>
						<th>{{ $t('No') }}</th>
						<th>{{ $t('Name') }}</th>
						<th>{{ $t('Email') }}</th>
						<th>{{ $t('Role') }}</th>
						<th>{{ $t('Last Login') }}</th>
						<th width="20%"></th>
					</tr>
				</thead>
				<div class="p-5 text-center absolute"  v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<tbody>
					<tr
						v-for="(item, index) in filteredSelfCollaborator"
						:key="item.id">
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ numberingList(index) }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.name }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.email }}</td>
						<td @mouseover="itemHover(item)" v-if="item.role === 'operator'" @mouseleave="itemLeave(item)">{{ formatText(item.role) }}</td>
						<td @mouseover="itemHover(item)" v-if="item.role === 'event_manager'" @mouseleave="itemLeave(item)">Creator</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ getRelativeTime(item) }}</td>
						<td class="btn-action-table" @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<button v-if="hover && hoverItem === item.id && !item.logged_in_at"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Resend Invitation')"
								:disabled="disableResend.includes(item.id)"
								@click="resendConfirmation(item.id)">
								<i class="material-icons md-18">email</i>
							</button>
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								@click="editItem(item)">
								<i class="material-icons md-18">edit</i>
							</button>
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-danger btn-icon"
								@click="confirmRemoveItem(item)">
								<i class="material-icons md-18">delete</i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="text-center absolute disabled mt-4" v-if="filteredSelfCollaborator.length === 0 && !isFetching">{{$t('No Collaborators available')}}</div>
			<!-- Table Pagination -->
			<pagination
				v-if="!isFetching"
				:total-pages="totalPages"
				:current-page="page"
				:last-page="lastPage"
				@select="onPageSelected">
			</pagination>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!-- Data Form -->
			<collaborator-form
				:data="selected"
				@saved="insertItem"
				@close="isFormVisible = false"
				v-if="isFormVisible"
				:mineRole="mineRole"
				:rundownParent="rundowns"
			/>
			<!-- Delete Confirmation -->
			<modal
				size="small"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible && selected">
				<template slot="header">
					<h3>{{ $t('Remove User') }}</h3>
				</template>
				<template slot="body">
					{{ $t('Are you sure want to delete') }} {{ showModalName(selected.name) }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="removeItem(selected)">
							{{ $t('Remove') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- export data -->
			<modal
				size="small-tall"
				@close="isExportUserVisible = false"
				v-if="isExportUserVisible"
				:hide-footer="true">
				<template slot="header">
					{{ $t('Export Collaborator') }}
				</template>
				<template slot="body">
				<div class="pb-3">
					<p class="text-base text-white mb-3">
						{{ $t('Please select file format for data export') }}:
					</p>
					<div class="p-2">
						<div
							class="pointer"
							:class="{ 'is-loading': isExporting }"
							@click="exportUsers('excel')">
							<img src="/img/xls.png" alt="xls" width="20px;"/>
							<span class="ml-2 text-base item-text-export text-white">{{ $t('Excel File') }}</span>
						</div>
					</div>
					<div class="p-2">
						<div
							class="pointer"
							:class="{ 'is-loading': isExporting }"
							@click="exportUsers('docx')">
							<img src="/img/doc.png" alt="xls" width="20px;"/>
							<span class="ml-2 text-base item-text-export text-white">{{ $t('Document File') }}</span>
						</div>
					</div>
				</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import Modal from '@/components/Modal.vue';
import CollaboratorForm from '@/components/CollaboratorForm.vue';
import Pagination from '@/components/Pagination.vue';
import {
	getAxiosErrorMessage,
	delay,
	convertTimezone,
	addZeroUTC,
	elpisisString,
	downloadBlob,
} from '@/lib/helper';
import collaboratorsApi from '@/api/collaborators';
import rundownsApi from '@/api/rundowns';

dayjs.extend(utc);

export default {
	name: 'collaborators',
	components: {
		Modal,
		CollaboratorForm,
		Pagination,
		Loading,
	},
	data() {
		return {
			page: 1,
			limit: 10,
			orderBy: 'logged_in_at',
			sortBy: 'desc',
			keyword: '',
			isAll: false,
			items: [],
			selected: null,
			// totalPages: 2,
			totalItems: 0,
			lastPage: 1,
			isFormVisible: false,
			isConfirmRemoveVisible: false,
			isRemoving: false,
			title: 'Collaborators',
			inviter: 'All',
			inviters: [],
			mineRole: '',
			isFetching: false,
			hover: false,
			hoverItem: null,
			rundowns: [],
			isResetting: false,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			isExportUserVisible: false,
			isExporting: false,
			pausedFor60Seconds: false,
			disableResend: [],
			disableInterval: null,
		};
	},
	beforeDestroy() {
		clearInterval(this.disableInterval);
	},
	methods: {
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
		},
		itemHover(item) {
			this.hover = true;
			this.hoverItem = item.id;
		},
		...mapActions({
		}),
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) {
				this.page = page;
			}
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) {
					this.isAll = true;
				}
				this.items = items;
				this.items.forEach((item) => {
					const disableButton = localStorage.getItem(`disable-${item.id}`);
					if (disableButton) {
						this.disableResend.push(item.id);
					}
				});
				this.disableInterval = setInterval(() => {
					this.disableResend.forEach((id, index, obj) => {
						const item = localStorage.getItem(`disable-${id}`) ? parseInt(localStorage.getItem(`disable-${id}`)) : 0;
						if (item >= 60) {
							localStorage.removeItem(`disable-${id}`);
							obj.splice(index, 1);
						} else {
							localStorage.setItem(`disable-${id}`, (item) + 1);
						}
					});
				}, 1000);
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
				const isEdit = this.$route.query && this.$route.query.edit ? this.$route.query.edit : '';
				const colabId = this.$route.query && this.$route.query.id ? this.$route.query.id : '';
				if (isEdit) {
					const item = this.items.find(({ id }) => id === parseInt(colabId));
					if (item) this.editItem(item);
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetching = false;
			};
			collaboratorsApi.getList(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
			}, 500);
		},
		insertItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
			} else {
				this.$set(this.items, index, item);
			}
		},
		addItem() {
			this.selected = null;
			this.isFormVisible = true;
		},
		editItem(item) {
			this.selected = item;
			this.isFormVisible = true;
			if (this.inviter !== 'All') {
				this.getMine();
			}
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				const index = this.items.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.items.splice(index, 1);
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove User',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove User',
					text: message,
				});
			};
			collaboratorsApi.delete(item.id, callback, errorCallback);
		},
		onPageSelected(page) {
			this.fetch(true, page);
		},
		convertUTC(date) {
			const d = new Date(date);
			const h = addZeroUTC(d.getUTCHours());
			const m = addZeroUTC(d.getUTCMinutes());
			const s = addZeroUTC(d.getUTCSeconds());
			return `${h}:${m}:${s}`;
		},
		getRelativeTime(item) {
			let time = '-';
			if (item.logged_in_at) {
				if (!item.timezone) {
					time = item.logged_in_at;
					time = new Date(time);
					const result = `${time.getDate()}-${(time.getMonth() + 1)}-${time.getFullYear()}/${this.convertUTC(item.logged_in_at)}`;
					time = result;
				} else {
					time = convertTimezone(item.logged_in_at, item.timezone);
				}
			}
			return time;
		},
		getMine() {
			const callback = (response) => {
				const item = response.data;
				this.mineRole = item.role;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
			};
			collaboratorsApi.getMine(this.inviter, callback, errorCallback);
		},
		fetchInviter() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				user_id: this.user.id,
			};
			const callback = (response) => {
				const items = response.data;
				this.inviters = items;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
			};
			collaboratorsApi.getList(params, callback, errorCallback);
		},
		formatText(str) {
			const text = str.split('_');
			let i = 0;
			for (i; i < text.length; i++) {
				text[i] = text[i].charAt(0).toUpperCase() + text[i].slice(1);
			}
			return text.join(' ');
		},
		fetchRundown() {
			this.isFetching = true;
			const callback = (response) => {
				const items = response.data;
				this.rundowns = items;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetching = false;
			};
			const paramsRundown = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				is_archived: 1,
				user_id: this.user.id,
			};
			rundownsApi.getList(paramsRundown, callback, errorCallback);
		},
		resendConfirmation(id) {
			this.disableResend.push(id);
			localStorage.setItem(`disable-${id}`, 1);
			this.isResetting = true;
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Resend Invitation',
					text: message,
				});
				this.isResetting = false;
			};
			const errorCallback = () => {
				this.isResetting = false;
			};
			collaboratorsApi.resendConfirmation(id, callback, errorCallback);
		},
		showModalName(str) {
			return elpisisString(str);
		},
		exportUsers(type) {
			this.isExporting = true;
			const params = {
				order_by: 'name',
				sort_by: this.sortBy,
				role: '',
				keyword: '',
			};
			if (this.inviter === 'All') {
				params.inviter_id = this.user && this.user.id ? this.user.id : '';
			} else {
				params.inviter_id = this.inviter;
			}
			const callback = (response) => {
				const contents = response;
				downloadBlob(contents, { name: `${this.$t('Collaborators')}`, type });
				this.isExporting = false;
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			collaboratorsApi.exportList(type, params, callback, errorCallback);
		},
		changeLimit(value) {
			this.limit = value;
			this.fetch(true);
		},
		lastLoginAt(filter) {
			if (filter === 'all') {
				this.orderBy = 'id';
			} else {
				this.orderBy = 'logged_in_at';
			}
		},
		sortFilter(filter) {
			if (filter === 'asc') {
				this.sortBy = 'asc';
			} else {
				this.sortBy = 'desc';
			}
		},
		numberingList(index) {
			if (this.page >= 1) {
				return index + 1 + (this.page * 10 - 10);
			}
			return index + 1;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
			};
			if (this.inviter === 'All') {
				params.inviter_id = this.user.id;
			} else {
				params.inviter_id = this.inviter;
			}
			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
		filteredInvitedOptions() {
			const filter = item => (item.user_id !== item.inviter_id);
			return this.inviters.filter(filter);
		},
		filteredSelfCollaborator() {
			const filter = item => (item.user_id !== this.user.id);
			return this.items.filter(filter);
		},
	},
	created() {
		this.fetch();
		this.fetchInviter();
		this.fetchRundown();
	},
	watch: {
		sortBy() {
			this.fetch(true);
		},
	},
};
</script>
